import { cn } from '@/new/lib/utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="skeleton" className={cn('animate-pulse rounded-md bg-gray-100', className)} {...props} />;
}

export { Skeleton };
